export const feedback = {
	LOCATION: 'Project Components',
	GLOBAL_COMPONENTS: 'jsw.components.global-components',
};
